import "./spinner.scss"
import React from "react";

/**
 * Spinner component
 * 
 * @returns JSX
 */
const Spinner = () => (
    <div className="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
    </div>
)

export default Spinner;
